/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import { createStore, applyMiddleware, compose } from 'redux';
import CombinedReducers from './reducers/CombinedReducers';
import thunkMiddleware from 'redux-thunk';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const AWSHubStore = createStore(
  CombinedReducers,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);
export default AWSHubStore;
